//import HeatMap from 'screens/calls/map/heat'
import HighMap from 'screens/calls/map/highmaps'
import CallSummary from 'screens/calls/summary/index'
import CallList from 'screens/calls/list/index'
import Modality from 'screens/modality/index'
import DynamicDashboard from 'screens/dashboard/index'
import { testAndSet, createNameMap, createUrlMap } from 'helpers/constants_helper'
import { STAGE } from 'Constants'

// Menu structure. Edit here to update the sidebar everywhere. Add property "devOnly:true" 
// to create an item only viewable by dev
export const MENU = {
  sidebar: [
    { 
      url: "",
      title: "Menu.Dashboard",
      icon: "polycom home",
      isSelector: true,
      app: DynamicDashboard
    },
    {
      url: "calls",
      title: "Menu.Calls.Title",
      icon: "polycom call",
      children: [
        {
          url: "summary",
          title: "Menu.Calls.Summary",
          icon: null,
          isSelector: true,
          app: CallSummary,
        },
        { 
          url: "map",
          title: "Map",
          icon: null,
          isSelector: true,
          app: HighMap,
        },
        {
          url: "list",
          title: "Menu.Calls.List",
          icon: null,
          isSelector: true,
          app: CallList,
        }
      ]
    },
    { 
      url: "realconnect-invite-addin",
      title: "Menu.Modality.Title",
      icon: "polycom download",
      app: Modality,
    }
  ]
};

// make sure we have the links set up correctly, add in fullpath to each object
testAndSet(MENU.sidebar, STAGE);

// used if you want to find links by: URL.CALLS.LIST (for example)
export const URLName = createNameMap(MENU.sidebar);

// returns a map of urL:{url: full_path, app: app_name, title: title, fullTitle: fullTitle}
export const URLMap = createUrlMap(MENU.sidebar);

